export default __webpack_public_path__ + "static/media/1456.0a9278ce.png";